module.exports = __webpack_public_path__ + "img/filters.12935905.svg";